const ROLE_LABELS = {
  author: "Администратор",
  business: "Администратор",
  moderator: "Модератор",
};

const PACKAGE_LABELS = {
  biz_s_15: "Групповой доступ — до 15 чел.",
  biz_m_50: "Групповой доступ — 16–50 чел.",
  biz_l_100: "Групповой доступ — 51–100 чел.",
  l_start: "Старт — 5 одноразовых ключей",
  l_basic: "Базовый — 20 одноразовых ключей",
  l_pro: "Автор — 50 одноразовых ключей",
  l_wholesale: "Опт — 150 одноразовых ключей",
  sub_author: "Author — подписка 30 дней",
  t_smb_trial: "Тест — Team-ключ",
  t_smb_team: "Команда — Team-ключ",
  t_mmb_multi: "Отдел — Team-ключ",
  t_mmb_hr: "Компания — Team-ключ",
  t_pilot: "Pilot — Team-ключ",
  t_team: "Team — Team-ключ",
  t_hr: "HR Pack — Team-ключ",
};

export function getUserRoleLabel(type) {
  return ROLE_LABELS[type] ?? "Администратор";
}

/** id из state.user.data — после login плоский объект, после validate вложенный JWT payload */
export function getAuthUserIdFromState(userData) {
  return userData?.user?.id ?? userData?.id ?? null;
}

export function getPaymentPackageLabel(packageSize, packageId) {
  const id = packageId || packageSize;
  if (!id) return "Тариф MOGAME";
  return PACKAGE_LABELS[id] ?? "Тариф MOGAME";
}

export function formatPaymentPrice(price) {
  if (price == null || price === "") return "—";

  const numeric = Number(String(price).replace(",", "."));
  if (Number.isNaN(numeric)) return `${price} ₽`;

  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(numeric);
}

export function formatSubscriptionExpiry(subscription) {
  if (!subscription?.expiresAt) return null;

  const expiresAt = new Date(subscription.expiresAt);
  if (expiresAt <= new Date()) return null;

  return expiresAt.toLocaleDateString("ru-RU");
}

function pluralDays(days) {
  const mod10 = days % 10;
  const mod100 = days % 100;
  if (mod100 >= 11 && mod100 <= 14) return "дней";
  if (mod10 === 1) return "день";
  if (mod10 >= 2 && mod10 <= 4) return "дня";
  return "дней";
}

export function getSubscriptionAlert(subscription, storage = null) {
  if (!subscription?.expiresAt) return null;

  const expiresAt = new Date(subscription.expiresAt);
  if (Number.isNaN(expiresAt.getTime())) return null;

  const msPerDay = 24 * 60 * 60 * 1000;
  const daysLeft = Math.ceil((expiresAt.getTime() - Date.now()) / msPerDay);
  const expiryLabel = expiresAt.toLocaleDateString("ru-RU");
  const storageNote = storage?.usageLabel
    ? ` Место для видео: занято ${storage.usageLabel}.`
    : "";

  if (daysLeft <= 0) {
    return {
      severity: "error",
      title: "Доступ приостановлен",
      message:
        `Подписка закончилась. Групповой доступ к сценариям отключён.${storageNote} Продлите подписку, чтобы снова открыть доступ команде.`,
      cta: "Продлить подписку",
      ctaPath: "/main/price",
      expiredAt: expiryLabel,
    };
  }

  if (daysLeft === 1) {
    return {
      severity: "warning",
      title: "Завтра доступ будет приостановлен",
      message: `Подписка заканчивается ${expiryLabel}. Оплатите продление сегодня — иначе завтра групповой доступ к сценариям будет приостановлен.${storageNote}`,
      cta: "Продлить подписку",
      ctaPath: "/main/price",
      expiresAt: expiryLabel,
      daysLeft,
    };
  }

  if (daysLeft <= 5) {
    return {
      severity: "warning",
      title: `Подписка заканчивается через ${daysLeft} ${pluralDays(daysLeft)}`,
      message: `Оплатите продление до ${expiryLabel}. Автоматического списания нет — если подписка не будет продлена, групповой доступ будет приостановлен.${storageNote}`,
      cta: "Продлить подписку",
      ctaPath: "/main/price",
      expiresAt: expiryLabel,
      daysLeft,
    };
  }

  return null;
}

export function getStorageUsagePercent(storage) {
  if (!storage?.usedBytes || !storage?.limitBytes) return 0;
  return Math.min(100, Math.round((storage.usedBytes / storage.limitBytes) * 100));
}

export function formatStorageStatusLabel(storage) {
  if (!storage?.usageLabel) {
    return "10 ГБ включено на компанию";
  }
  return `Занято ${storage.usageLabel}`;
}

function formatGbShort(bytes) {
  const gb = bytes / (1024 * 1024 * 1024);
  return gb.toLocaleString("ru-RU", {
    minimumFractionDigits: 0,
    maximumFractionDigits: gb < 10 && gb % 1 !== 0 ? 1 : 0,
  });
}

export function formatStorageDashboardLabel(storage) {
  const limitBytes = storage?.limitBytes ?? 10 * 1024 * 1024 * 1024;
  const usedBytes = storage?.usedBytes ?? 0;
  return `${formatGbShort(usedBytes)}/${formatGbShort(limitBytes)} ГБ занято`;
}
